import { Injectable } from '@angular/core';
import { MFAPrefrences, MFAQRCodePayload, MFAUserPreferences, MFASettingsCombined } from '@shared/models/auth.interface';
import { appQRdata } from '@shared/models/mfa-prefrences.interface';
import { BehaviorSubject, Subject, Observable, catchError, finalize, of, tap } from 'rxjs';
import { AuthMFAService } from './auth/auth-mfa.service';
import { ExtendedLogDetails } from '@shared/models/log.interface';
import { SnackbarService, LoadingService } from '@shared/services/core';
import { LogService } from '@shared/services/core/log.service';

@Injectable({ providedIn: 'root' })
export class MfaDataService {
  public landingPageRoute: string = 'error/404';
  public jti: string = '';
  public rememberMe: boolean = true;

  constructor(private authService: AuthMFAService,
    private snackbarService: SnackbarService,
    private loadingService: LoadingService,
    private logService: LogService
  ) {

  }

  private mfaDataSubject = new BehaviorSubject<MFASettingsCombined | null>(null);
  mfaData$ = this.mfaDataSubject.asObservable();

  public loginTriggerSubject = new Subject<string | { error: string } | { otp: string; mfaAuthType: string, securityQuestions?: any }>();
  loginTrigger$ = this.loginTriggerSubject.asObservable();

  public qrCodeSubject = new BehaviorSubject<appQRdata | null>(null);


  setMfaData(data: MFASettingsCombined) {
    this.mfaDataSubject.next(data);
  }

  clearMfaData() {
    this.mfaDataSubject.next(null);
  }


  fetchQrCodeIfNeeded(payload: MFAQRCodePayload): Observable<appQRdata | null> {
    const qr = this.qrCodeSubject.value;
    if (!(qr && qr.QrCodeUrl)) {
      this.loadingService.showLoading();
      return this.authService.getMfaQrCode(payload).pipe(
        finalize(() => {
          this.loadingService.stopLoading();
        }),
        catchError((error: ExtendedLogDetails | undefined) => {
          this.logService.error('Error fetching QR code', error);
          this.snackbarService.showErrorSnackBar(
            'Error',
            'Failed to fetch QR code. Please try again later.',
            'none'
          );
          return of(null);
        }),
        tap((response: appQRdata | null) => {
          if (response) {
            this.qrCodeSubject.next(response);
          }
        })
      );
    } else {
      this.loadingService.stopLoading();
      // Return the current value as an observable
      return of(this.qrCodeSubject.value);
    }
  }
  get hasQrCode(): boolean {
    const qr = this.qrCodeSubject.value;
    return !!(qr && qr.QrCodeUrl);
    // return !!this.qrCodeSubject.value;
  }

  get qrCode$(): Observable<appQRdata | null> {
    return this.qrCodeSubject.asObservable();
  }
}